import {combineReducers} from "redux";

import listeCommandesReducer from "./listeCommandes";
import commandeReducer from "./commande";


export default combineReducers({
    listeCommandes: listeCommandesReducer,
    commande: commandeReducer
});